import PropTypes from 'prop-types';

const displayName = 'PrivacyPolicy';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
